import {BackendApi} from '../api/api.ts'

export type GLMapping = {
    mappingId: string
    name: string
    usedByCount: number
}

export type GLMappingRule = {
    mappingId: string
    externalGlAccountCode: string
    externalGlAccountDescription: string
    glAccount: string
}

export function payrollMappingSettingsUrl(
    mappingId: string,
    opts?: {administrationId?: string; returnTo?: string},
): string {
    const params = new URLSearchParams()
    params.set('tab', 'payroll')
    params.set('mapping_id', mappingId)
    params.set('action', 'edit')
    if (opts?.administrationId) {
        params.set('administration_id', opts.administrationId)
    }
    if (opts?.returnTo) {
        params.set('return_to', opts.returnTo)
    }
    return `/my-profile?${params.toString()}`
}

export async function createGLMapping(api: BackendApi, name: string): Promise<GLMapping> {
    const response = await api.Partner__payroll__createPayrollGlMapping({name})
    return {mappingId: response.mapping_id, name: response.name, usedByCount: 0}
}

export async function listGLMappings(api: BackendApi): Promise<GLMapping[]> {
    const response = await api.Partner__payroll__glMappings__list({})
    return response.mappings.map(m => ({mappingId: m.mapping_id, name: m.name, usedByCount: m.used_by_count}))
}

export async function getGLMapping(
    api: BackendApi,
    mappingId: string,
): Promise<{mapping: GLMapping; rules: GLMappingRule[]}> {
    const response = await api.Partner__payroll__getPayrollGlMapping(mappingId)
    return {
        mapping: {mappingId: response.mapping_id, name: response.name, usedByCount: response.used_by_count},
        rules: response.rules.map(r => ({
            mappingId: response.mapping_id,
            externalGlAccountCode: r.external_gl_account_code,
            externalGlAccountDescription: r.external_gl_account_description,
            glAccount: r.gl_account,
        })),
    }
}

export async function renameGLMapping(
    api: BackendApi,
    mappingId: string,
    name: string,
): Promise<GLMapping> {
    const response = await api.Partner__payroll__glMappings__rename({mapping_id: mappingId, name})
    return {mappingId: response.mapping_id, name: response.name, usedByCount: 0}
}

export async function deleteGLMapping(api: BackendApi, mappingId: string): Promise<void> {
    await api.Partner__payroll__glMappings__delete({mapping_id: mappingId})
}

export async function upsertGLMappingRule(
    api: BackendApi,
    mappingId: string,
    code: string,
    description: string,
    glAccount: string,
): Promise<GLMappingRule> {
    const response = await api.Partner__payroll__glMappingRules({
        mapping_id: mappingId,
        external_gl_account_code: code,
        external_gl_account_description: description,
        gl_account: glAccount,
    })
    return {
        mappingId: response.mapping_id,
        externalGlAccountCode: response.external_gl_account_code,
        externalGlAccountDescription: response.external_gl_account_description,
        glAccount: response.gl_account,
    }
}

export async function removeGLMappingRule(
    api: BackendApi,
    mappingId: string,
    code: string,
): Promise<{mappingId: string; externalGlAccountCode: string}> {
    const response = await api.Partner__payroll__glMappingRules__remove({
        mapping_id: mappingId,
        external_gl_account_code: code,
    })
    return {mappingId: response.mapping_id, externalGlAccountCode: response.external_gl_account_code}
}
